import LocalConvenienceStoreIcon from '@mui/icons-material/LocalConvenienceStore';
import PatronPointsStoreList from './List';
import PatronPointsStoreEdit from './Edit';

const conf = {
    name: 'onpoint_patron_points_stores',
    icon: <LocalConvenienceStoreIcon />,
    list: PatronPointsStoreList,
    edit: PatronPointsStoreEdit,
    options: {
        label: "Patron Stores",
        items: true
    }
};

export default conf